/* Built In Imports */

/* External Imports */
import { Box, Image } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
/* Internal Imports */
/* Components */
import StructuredTextContent from '@components/UI/StructuredTextContent';
import MediaEmbedV2 from '@components/Embeds/MediaEmbedV2';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import QuoteSymbolImageSignature from '@components/Quotes/QuoteSymbolImageSignature';
import MidContainer from '@Layout/MidContainer';

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 *
 * @returns {ReactElement} ImageBannerAd component
 */
const YouTubeContent = ({ sectionContent }) => {
    const isLessThen = useMediaQuery({ maxWidth: 560 });
    return (
        <MidContainer
            pt="40px"
            w="100%"
            px={{ base: '0', md: 'auto' }}
            mb={{ base: '40px', md: '50px' }}
            background={{
              base: 'linear-gradient(#29241F 50%, #fff 0%)',
              md: 'linear-gradient(#29241F 44%, #fff 0%)',
            }}
          >
        <Box m="0 0 30px 0">
            <Box textAlign={'center'} m="0 auto 30px auto">
                <QuoteSymbolImageSignature sectionContent={sectionContent[0]} txtcolor={'#ffffff'} padding={{base:'0 16px', md:'0 10px'}} />
                <LazyLoadImageComponent
                    h={'auto'}
                    alt={sectionContent[1].image?.alt}
                    title={sectionContent[1].image?.title}
                    textAlign="center"
                    src={isLessThen ? (sectionContent[1].mobileImage?.url != null ? sectionContent[1].mobileImage?.url : sectionContent[1].image?.url) : sectionContent[1].image?.url}
                    w={'141px'}
                    m="0 auto"
                    maxWidth={'100%'}
                />
            </Box>
            <Box
              pos={'relative'}
              maxWidth={'762px'}
              margin={'0 auto'}
              w={{ base: '90%' }}
            >
                <MediaEmbedV2 sectionContent={sectionContent[2]} 
                  width={{ base: '100%', md: '762px' }} bgcolor={'#BB3E03'} txtcolor={'#ffffff'} />
            </Box>
            <Box 
                fontSize={'16px'}
                lineHeight={{ base: '28px', md: '28px' }}
                fontFamily="FedraSansStd-book"
                color="#28231E"
                width={{base:'90%', md:'590px'}}
                display={'flex'}
                m="0 auto"
            >
                {StructuredTextContent(sectionContent[3].body)}
            </Box>
        </Box>
        </MidContainer>
    );
};

export default YouTubeContent;
